import { ENDPOINT } from "../utils/constants";
import { getServerUrl, oAuthRequest } from "../utils/request";

export const getUserEnrollments = (page=null,pageSize=null) => {

    let serviceBaseAddress = getServerUrl();

    return oAuthRequest({
        url:`${serviceBaseAddress}${ENDPOINT.USER_UTILS}/enrollments${page && pageSize?`?page=${page}&pageSize=${pageSize}`:``}`,
        method: 'get',
    });

}

export const getUserBadges = (page=null,pageSize=null) => {

    let serviceBaseAddress = getServerUrl();

    return oAuthRequest({
        url:`${serviceBaseAddress}${ENDPOINT.USER_UTILS}/badges${page && pageSize?`?page=${page}&pageSize=${pageSize}`:``}`,
        method: 'get',
    });

}

export const getUserEnrollmentById = (enrollmentId) => {

    let serviceBaseAddress = getServerUrl();

    return oAuthRequest({
        url:`${serviceBaseAddress}${ENDPOINT.USER_UTILS}/enrollment/${enrollmentId}`,
        method: 'get',
    });

}

export const getUserEnrollmentByAssetId = (assetId) => {

    let serviceBaseAddress = getServerUrl();

    return oAuthRequest({
        url:`${serviceBaseAddress}${ENDPOINT.USER_UTILS}/enrollment/by-asset-id/${assetId}`,
        method: 'get',
    });

}

